const state = {
    incomes: [],
    incomeList: [],
    incomeId: [],
    loading: false
};

export default state;